import {useContext, useMemo} from 'react';
import cx from 'classnames';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {Container} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Container';
import {Stamp} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/Stamp';
import {RevealEditor} from './RevealEditor';
import {OverlayAnimation} from '~/common/OverlayAnimation/OverlayAnimation';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';

export const RevealContainer = ({children}) => {
  const isLargishAndUp = useIsLargishAndUp();
  const {revealVideo} = useContext(EventCreateContext);
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  const revealAnimation = useMemo(
    () => <OverlayAnimation autoPlay revealVideo={revealVideo} fixed />,
    [revealVideo]
  );

  return (
    <>
      <Container
        className={cx('event-create-editor event-create-editor--reveal', {
          'onestep-edit-ABTest__editor-wrapper': isInEditButtonTest,
        })}
      >
        {children}
        <Stamp />
        {isLargishAndUp && <RevealEditor />}
      </Container>
      {revealAnimation}
    </>
  );
};
